/**
 * @generated SignedSource<<9d580f0a593bf6080be441e665d29e08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TiktokGoStatus = "approved" | "pending" | "rejected";
import { FragmentRefs } from "relay-runtime";
export type SnsAssociationTiktokOAuth$data = {
  readonly linkingTiktok: boolean | null;
  readonly profile: {
    readonly isTiktokGoCreator: boolean;
    readonly tiktokGoStatus: TiktokGoStatus;
    readonly tiktokGoUniqueId: string | null;
  };
  readonly " $fragmentType": "SnsAssociationTiktokOAuth";
};
export type SnsAssociationTiktokOAuth$key = {
  readonly " $data"?: SnsAssociationTiktokOAuth$data;
  readonly " $fragmentSpreads": FragmentRefs<"SnsAssociationTiktokOAuth">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SnsAssociationTiktokOAuth",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkingTiktok",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InfluencerInfo",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isTiktokGoCreator",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tiktokGoStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tiktokGoUniqueId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "b3ead776b2ed8575511a5749f540eda2";

export default node;
